var link_viewer_wrapper_default = {
  "anchor": "X9KMb",
  "link": "mfG-e"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
